
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tematicas",
      function () {
        return require("private-next-pages/tematicas/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tematicas"])
      });
    }
  